import React from "react";
import { useDrag } from "react-dnd";
import { NavLink } from "react-router-dom";
import { ItemTypes } from "./constants";

function Actor(props) {
  const { actor, index, filmId } = props;

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.ACTOR, actor },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return (
    <tr
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "grab"
      }}
    >
      <td>
        <i className="material-icons dark">drag_indicator</i>
        <NavLink to={`/films/${filmId}/actors/${actor.id}/edit`}>
          {actor.name}
        </NavLink>
      </td>
    </tr>
  );
}

export default Actor;
